import ReCAPTCHA from 'react-google-recaptcha';
import { FormFieldProps } from '../../form/FormTypes';
import { useEffect, useRef, useState } from 'react';
import { FormFieldRecaptcha as FormFieldRecatpchaProps } from '../../../../component-props';
import { FormfieldContainer } from '@greystar/designsystem';

const GOOGLE_RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY ?? '';

export const FormFieldRecaptcha = (
  props: FormFieldRecatpchaProps & FormFieldProps
): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [valid, setValid] = useState<boolean>(true);
  const [silent, setSilent] = useState<boolean>(true);

  //Init ref to form
  useEffect(() => {
    props.fieldRefs[props.id as string] = {
      ref,
      isValid,
    };
  }, []);

  const isValid = () => {
    const valid = !!recaptchaRef.current?.getValue();
    setValid(valid);
    return valid;
  };

  const onChange = () => {
    setSilent(false);
    isValid();
  };

  return (
    <FormfieldContainer
      ref={ref}
      id={props.id as string}
      label=""
      fieldErrorMessage={props.fields.errorMessage.value}
      hasError={!valid && (!props.formSilent || !silent)}
    >
      <ReCAPTCHA ref={recaptchaRef} sitekey={GOOGLE_RECAPTCHA_SITE_KEY} onChange={onChange} />
    </FormfieldContainer>
  );
};
